export const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        let city = 'Your Location';
        let address = '';
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await res.json();
          address = data.display_name || '';
          city =
            data.address.city ||
            data.address.town ||
            data.address.village ||
            data.address.county ||
            'Your Location';
        } catch (_) {}
        resolve({ latitude, longitude, city, address });
      },
      (error) => reject(error)
    );
  });
};

export const getStoredLocation = () => {
  const stored = localStorage.getItem('userLocation');
  if (!stored) return null;
  const parsed = JSON.parse(stored);
  // Invalidate old format that had isInPune instead of city
  if (!parsed.city) {
    localStorage.removeItem('userLocation');
    return null;
  }
  return parsed;
};

export const storeLocation = (locationData) => {
  localStorage.setItem('userLocation', JSON.stringify(locationData));
};

export const clearStoredLocation = () => {
  localStorage.removeItem('userLocation');
};
